import {FormControl, FormGroup, Validators} from "@angular/forms";
import {FormArray} from "../../../../shared/types/form-array.interface";
import {Model3dForm, modifyModel3dForm} from "./model3d.form";
import {LamellaForm} from "./lamella.form";
import {fetchFile} from "../../../../shared/util/fetchFile";

const isNumberRegex = /^[0-9]*$/;

export interface ProductForm {
    id: FormControl<string>;
    name: FormControl<string>;
    productCode: FormControl<string>;
    coverImageFile: FormControl<File>;
    measureImageFile: FormControl<File>;
    url: FormControl<string>;
    width: FormControl<number>;
    height: FormControl<number>;
    depth: FormControl<number>;
    subProducts: FormControl<boolean>;
    hasSubProducts: FormControl<number>;
    productType: FormControl<string>;
    newProductType?: FormControl<string | null>;
    lamella?: FormGroup<LamellaForm>;
    model3d: FormArray<FormGroup<Model3dForm>>;
}

export function getProductForm(product: any = undefined) {

    const form = new FormGroup( <ProductForm> {
        id: new FormControl(product?.id ?? undefined),
        name: new FormControl(product?.name ?? '', [Validators.required]),
        productCode: new FormControl(product?.productCode ?? '', [Validators.required]),
        coverImageFile: new FormControl(undefined),
        measureImageFile: new FormControl(undefined),
        url: new FormControl(product?.url ?? ''),
        width: new FormControl(product?.width ?? 0, [Validators.pattern(isNumberRegex), Validators.min(0)]),
        height: new FormControl(product?.height ?? 0, [Validators.pattern(isNumberRegex), Validators.min(0)]),
        depth: new FormControl(product?.depth ?? 0, [Validators.pattern(isNumberRegex), Validators.min(0)]),
        subProducts: new FormControl(product?.subProducts ?? false),
        hasSubProducts: new FormControl(product?.hasSubProducts ?? 0),
        productType: new FormControl(product?.productType ?? 'lamella', [Validators.required]),
        model3d: new FormArray<FormGroup<Model3dForm>>(
            product?.model3d
                ? [modifyModel3dForm(product?.model3d)]
                : []
        )
    })

    if(product?.coverImage) fetchFile(product?.coverImage).then(file=>form.controls.coverImageFile.setValue(file));
    if(product?.measureImage) fetchFile(product?.measureImage).then(file=>form.controls.measureImageFile.setValue(file));

    return form;
}